import toastr from 'toastr'
/*
*
* HANDLES THE JSON ERROR RESONSE FROM LARAVEL
*
*/
function errorMaker (errors) {
  console.log(errors)
  var opts = {
    title: 'Something went wrong',
    text: 'Please try your request again.'
  }
  if (errors) {
    opts.text = "<ul><li class='title'>Please correct the following errors:</li>"

    for (var i = 0, len = errors.length; i < len; i++) {
      opts.text += '<li>' + errors[i]['msg'] + '</li>'
    }
    opts.text += '</ul>'
  }

  toastr.error(opts.text, opts.title, {'positionClass': 'toast-bottom-right', 'closeButton': true})
}
export {errorMaker}



// WEBPACK FOOTER //
// ./src/utils/errorHandler.js